// extracted by mini-css-extract-plugin
export var displayNone = "_s2-6";
export var imgContainer = "_s2-2";
export var overflowHidden = "_s2-3";
export var productInfoCardButtonContainer = "_s2-5";
export var productTitleText = "_s2-4";
export var rightArrow = "_s2-1";
export var rightArrowContainer = "_s2-0";